import { useState } from 'react';
import { Download } from 'lucide-react';
import { Button } from '../components/ui/button';
import { downloadLatestInstaller } from './downloadApp';

interface Props {
  variant?: React.ComponentProps<typeof Button>['variant'];
  size?: React.ComponentProps<typeof Button>['size'];
  className?: string;
  children?: React.ReactNode;
  /** Called after the click is handled (e.g. close the mobile menu). */
  onDone?: () => void;
}

/** "Download for Windows" CTA — resolves the latest installer and starts
 *  the download in place. Shows a busy label during the API lookup. */
export function DownloadAppButton({ variant, size, className, children, onDone }: Props) {
  const [busy, setBusy] = useState(false);

  const handleClick = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await downloadLatestInstaller();
    } finally {
      setBusy(false);
      onDone?.();
    }
  };

  return (
    <Button
      variant={variant}
      size={size}
      className={className}
      onClick={handleClick}
      disabled={busy}
    >
      <Download className="size-4" aria-hidden="true" />
      {busy ? 'Preparing…' : (children ?? 'Download for Windows')}
    </Button>
  );
}
